import React, { useEffect, useState } from 'react'

import { useQuery } from 'react-query'
import { useRouter } from 'next/router'
import { SortEnum } from '@interfaces/SortEnum'
import { useAuthentication } from '@hooks/useAuthentication'
import { WriterSalesAnalyticsDetailDataType } from '@models/myWriting/salesAndAnalytics/WriterSalesAnalyticsDetailDataType'
import { EbookSalesAnalyticsDetailReportEnum } from '@interfaces/EbookSalesAnalyticsDetailReportEnum'
import { WriterSalesGraphTypeEnum } from '@interfaces/WriterSalesGraphTypeEnum'
import { useMyWritingAction } from '@hooks/book/myWriting/useMyWritingAction'
import { SalesAnalyticsDetailEbookDataType } from '@models/myWriting/salesAndAnalytics/SalesAnalyticsDetailEbookDataType'
import {
  EbookOverviewTabsAcceptProps,
  EbookOverviewTabsProps,
  SortEbookTableType,
} from './interface'

const initialData: SalesAnalyticsDetailEbookDataType = {
  tableData: [],
  graphData: [],
  graphType: WriterSalesGraphTypeEnum.MONTH,
}

export function withEbookOverviewTabs(
  Component: React.FC<EbookOverviewTabsProps>
) {
  function WithEbookOverviewTabs({
    queryParams,
    ...props
  }: EbookOverviewTabsAcceptProps) {
    const router = useRouter()
    const myWritingClient = useMyWritingAction()
    const { user, isAuthenticated, isWriter } = useAuthentication()
    const [sortParams, setSortParams] = useState<SortEbookTableType>({
      ebookReportType: EbookSalesAnalyticsDetailReportEnum.SALES,
      sortKey: 'total',
      sortValue: SortEnum.DESC,
    })

    const queryKey = [
      'ebook-sales-analytics-detail',
      user.id,
      queryParams,
      sortParams,
    ]

    const { data = initialData, isLoading } = useQuery(
      queryKey,
      () =>
        myWritingClient.getWriterSalesAnalyticsEbookDetail(
          queryParams,
          sortParams
        ),
      {
        enabled: !!isAuthenticated && isWriter,
      }
    )

    function handleSortChange(sortKey: string, sortValue: SortEnum) {
      setSortParams(prev => ({
        ...prev,
        sortKey,
        sortValue,
      }))
    }

    function handleTabChange(value: string) {
      router.replace(
        {
          pathname: '/my-writing',
          query: {
            ...router.query,
            ebookReportType: value,
          },
        },
        undefined,
        { scroll: false }
      )
    }

    useEffect(() => {
      setSortParams({
        ebookReportType:
          (router.query
            .ebookReportType as EbookSalesAnalyticsDetailReportEnum) ||
          EbookSalesAnalyticsDetailReportEnum.SALES,
        sortKey: 'total',
        sortValue: SortEnum.DESC,
      })
    }, [router.query.ebookReportType])

    const newProps = {
      ...props,
      queryParams,
      sortParams,
      isLoading,
      data,
      handleTabChange,
      handleSortChange,
    }
    return <Component {...newProps} />
  }
  return WithEbookOverviewTabs
}
